import { render, staticRenderFns } from "./ModalProductos.vue?vue&type=template&id=fa1af3cc&scoped=true&"
import script from "./ModalProductos.vue?vue&type=script&lang=js&"
export * from "./ModalProductos.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductos.vue?vue&type=style&index=0&id=fa1af3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1af3cc",
  null
  
)

export default component.exports